import {createSelector} from "reselect";
import {DateTime} from "luxon";
import {first, get, last} from "lodash";
import {getContest, getContestRequestStates} from "modules/selectors/json";
import {
	getAnswers,
	getAnswersRequestState,
	getIsFriendlyCountryState,
} from "modules/selectors/game";

// after lockout user can't change answers
export const getIsLockout = createSelector(getContest, (contest) => {
	const now = DateTime.local();
	const time = contest?.endDate;
	return time ? now > DateTime.fromISO(time) : false;
});

export const getIsLoadingPredictor = createSelector(
	getContestRequestStates,
	getAnswersRequestState,
	(contestRequestStates, answersRequestState) =>
		!contestRequestStates.isComplete || answersRequestState.isLoading
);

export const getCTAModalData = createSelector(
	getContest,
	getIsFriendlyCountryState,
	(contest, isFriendly) => {
		if (!contest) {
			return;
		}

		return contest?.[isFriendly];
	}
);

export const getNextQuestionId = createSelector(getContest, getAnswers, (contest, answers) => {
	if (!contest) {
		return null;
	}

	const questions = contest.questions;
	const lastAnswerQuestionId = last(answers)?.questionId;
	const lastAnswerQuestion = questions.find(({id}) => id === lastAnswerQuestionId);
	const unAnsweredQuestion = contest.questions.filter(
		({id}) => !answers.find((answer) => answer.questionId === id)
	);

	if (lastAnswerQuestion) {
		const nextQuestion = unAnsweredQuestion.find(
			({position}) => lastAnswerQuestion.position < position
		);

		return get(nextQuestion, "id") || get(first(unAnsweredQuestion), "id");
	}

	return null;
});
